
import { connectHits } from 'instantsearch.js/es/connectors';
import connectConfigureRelatedItems from 'instantsearch.js/es/connectors/configure-related-items/connectConfigureRelatedItems';

const renderHits = (renderOptions, isFirstRender) => {
    const { hits, widgetParams, results } = renderOptions;
    // let themePath = $('.tematik_produits').data('theme-path');
    // let defaultImg = themePath + "/img/photos/default-img.svg";
    // let baseUrl = $('.tematik_produits').data('url');
    let ficheProduitUrl = $('.moteurRecherche').data('fiche-produit-url');
    let ficheRecetteUrl = $('.moteurRecherche').data('fiche-recette-url');
    let ficheIngredientUrl = $('.moteurRecherche').data('fiche-ingredient-url');

    const generateUrl = (item) => {
        if (item.facette === 'produit') {
            return ficheProduitUrl + '/' + item.url;
        }
        if (item.facette === 'recette') {
            return ficheRecetteUrl + '/' + item.url;
        }
        if (item.facette === 'ingredient') {
            return ficheIngredientUrl + '/' + item.url;
        }
        if (item.facette === 'page') {
            return item.url;
        }
    }

    const generateDescription = (item) => {
        if (item.facette === 'recette' && item.informations_nutritionnelles != undefined) {
            return item.informations_nutritionnelles.substr(0,127);
        }else if (item.description != undefined) {
            return item.description.substr(0,127);
        } else {
            return "";
        }
        
    }
    
    if (!results || (results.query === "")) {
        widgetParams.paginationContainer.style.display = 'none';
        widgetParams.container.innerHTML = ``;
    } else {
        widgetParams.paginationContainer.style.display = 'block';
        widgetParams.container.style.display = "block";
        widgetParams.container.innerHTML = `
            ${hits.map(item => `
            <div class="pageRecherche-resultats-hit">
                <a class="pageRecherche-resultats-item" href="${generateUrl(item)}">
                    <span class="pageRecherche-resultats-facette badge badge-pill">${item.facette}</span>
                    <div class="pageRecherche-resultats-contenu">
                        <h2 class="pageRecherche-resultats-titre">
                        ${item.nom}
                        ${item.conditionnement && item.unite_conditionnement ?
                            ` - ${item.conditionnement} ${item.unite_conditionnement}` 
                            : ''}
                        </h2>
                        <p>${generateDescription(item)}</p>
                    </div>
                </a>
            </div>`
            ).join('')}`;
        };
      
    }
  const customHitsRecherche = connectHits(renderHits);
 
  export default customHitsRecherche;